import { useNavigate } from "react-router-dom";
import { coachPaths } from "../routes/coach";
import { useEffect, useState } from "react";
import CoachSignUp from "../components/Modals/SignupSteps";
import CoachSignUpStep1Modal from "../components/Modals/SignupSteps/CoachSignUpStep1Modal";
import CoachSignUpStep2Modal from "../components/Modals/SignupSteps/CoachSignUpStep2Modal";
import CoachSignUpStep3Modal from "../components/Modals/SignupSteps/CoachSignUpStep3Modal";
import CoachLogin from "../components/Modals/CoachLoginModal";
import CoachForgotPassword from "../components/Modals/ForgotPassword";
import { useDispatch, useSelector } from "react-redux";
import useAppNavigate from "../components/hooks/useAppNavigate";
import ResetPassword from "../components/Modals/ForgotPassword/ResetPassword";
import OtpVerification from "../components/Modals/ForgotPassword/OtpVerification";
import { fetchCoachCategories } from "../redux/features/coach/actions/authAction";

const BootCampLayout = ({ children, user }) => {
    const { goTo, goBack } = useAppNavigate();
    const { isLoading } = useSelector((state) => state.coach.auth);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [isSignUp, setIsSignUp] = useState(false);
    const [isLogin, setIsLogin] = useState(false);

    const [isForgot, setIsForgot] = useState(false);
    const [signStepup, setSignupStep] = useState("0");

    const [isOtp, setIsOtp] = useState(false);
    const [isSetPassword, setIsSetPassword] = useState(false);

    const [dbCode, setDbCode] = useState("");
    const [email, setEmail] = useState("");

    const [isLoad, setIsLoad] = useState(false);

    useEffect(() => {
        if (isSignUp && signStepup == "2") {
            setIsLoad(true);
            dispatch(fetchCoachCategories()).then((res) => {
                setIsSignUp(true);
                setIsLoad(false);
                setSignupStep('2');
            });
        }
    }, [signStepup]);

    return (
      <>
        <header class="ct_header ct_dash_short_header">
          <div class="ct_logo">
            <a>
              <img src="assets/img/Nuvio_logo.png" alt="" />
            </a>
          </div>
          <div class="ct_navbar ">
            <ul className="justify-content-end gap-sm-5 gap-4 overflow-hidden">
              <div class="ct_close_menu">
                <i class="fa-solid fa-xmark"></i>
              </div>
              <li onClick={() => navigate(coachPaths.Bootcamp)}>
                <a
                  className={
                    `${window.location?.pathname}` == coachPaths?.Bootcamp &&
                    "active"
                  }
                >
                  Bootcamp
                </a>
              </li>
              <li onClick={() => navigate(coachPaths.AboutUs)}>
                <a
                  className={
                    `${window.location?.pathname}` == coachPaths?.AboutUs &&
                    "active"
                  }
                >
                  About
                </a>
              </li>
              <li onClick={() => navigate(coachPaths.ContactUs)}>
                <a
                  className={
                    `${window.location?.pathname}` == coachPaths?.ContactUs &&
                    "active"
                  }
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div class="d-flex align-items-center gap-4">
            <div class="ct_menu_bar">
              <i class="fa-solid fa-bars-staggered"></i>
            </div>
          </div>
        </header>

        {children}

        <footer class="ct_px_40 py-5">
          <div class="ct_footer_logo">
            <a>
              <img src="/assets/img/Nuvio_logo.png" alt="" />
            </a>
          </div>
          <div class="row pt-4">
            <div class="col-xxl-3 col-xl-2 col-md-6 mb-4">
              <div class="ct_footer_links">
                <h4 class="ct_fs_20 ct_darkblue_text mb-3">Navigation</h4>
                <ul>
                  <li>
                    <a onClick={(e) => goTo(e)}>For Enterprises</a>
                  </li>
                  <li>
                    <a onClick={(e) => goTo(e)}>For Freelancers</a>
                  </li>
                  <li>
                    <a onClick={(e) => goTo(e)}>CoachHUB</a>
                  </li>
                  <li>
                    <a onClick={(e) => goTo(e)}>Funding</a>
                  </li>
                  <li>
                    <a onClick={(e) => goTo(e, coachPaths?.AboutUs)}>
                      About us
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xxl-3 col-xl-2 col-md-6 mb-4">
              <div class="ct_footer_links">
                <h4 class="ct_fs_20 ct_darkblue_text mb-3">Resources</h4>
                <ul>
                  <li>
                    <a onClick={(e) => goTo(e)}>Blog</a>
                  </li>
                  <li>
                    <a onClick={(e) => goTo(e)}>Newsletter</a>
                  </li>
                  <li>
                    <a onClick={(e) => goTo(e)}>Tutorials</a>
                  </li>
                  <li>
                    <a onClick={(e) => goTo(e)}>Support</a>
                  </li>
                  <li>
                    <a onClick={(e) => goTo(e)}>Help Centre</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xxl-2 col-xl-3 col-md-6 mb-4">
              <div class="ct_footer_links">
                <h4 class="ct_fs_20 ct_darkblue_text mb-3">Get in Touch</h4>
                <ul>
                  <li>
                    <a
                      href="mailto:hello@nu-vio.com"
                      className="d-flex align-items-center gap-2"
                    >
                      <i class="fa-solid fa-envelope me-1 ct_yellow_text"></i>
                      <span>hello@nu-vio.com</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="tel:+33 6 66 92 57 30"
                      className="d-flex align-items-center gap-2"
                    >
                      <i class="fa-solid fa-phone me-1 ct_yellow_text"></i>{" "}
                      <span> +33 6 66 92 57 30</span>
                    </a>
                  </li>
                  <li>
                    <a className="d-flex align-items-center gap-2">
                      <i class="fa-solid fa-location-dot ct_yellow_text me-1"></i>{" "}
                      <span>
                        {" "}
                        Office 36, 1 Exchange Building (TBE), Cybercity, Ebene
                        Mauritius
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xxl-4 col-xl-5 col-md-6 mb-4">
              <div class="ct_newsletter_bg">
                <p>Ready to keep up with what’s next?</p>
                <div class="d-flex align-items-center gap-2 justify-content-between ct_flex_col_991">
                  <div class="form-group ct_flex_1 ct_w_100_991">
                    <input
                      type="email"
                      class="form-control ct_input ct_border_radius_100"
                      placeholder="Enter your email address"
                    />
                  </div>
                  <div class="ct_w_100_991">
                    <button class="ct_yellow_btn ct_darkblue_btn ct_border_radius_100 ct_h_48 ct_w_100_991">
                      Subscribe now
                    </button>
                  </div>
                </div>
              </div>
              <div class="pt-4">
                <h5 class="ct_fs_18 mb-3">Follow Us</h5>
                <div class="d-flex align-items-center gap-2">
                  <a style={{ color: "#0076B2" }}>
                    <i class="fa-brands fa-linkedin"></i>
                  </a>
                  <a style={{ color: "#3D5A98" }}>
                    <i class="fa-brands fa-square-facebook"></i>
                  </a>
                  <a style={{ color: "#FF0000" }}>
                    <i class="fa-brands fa-youtube"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="row pt-4 ct_border_top_1">
            <div class="col-md-12">
              <p class="mb-0 text-center">
                Copyright @ 2025 NUVIO All Rights Reserved
              </p>
            </div>
          </div>
        </footer>
        {isSignUp && signStepup == "0" && (
          <CoachSignUp
            backToLogin={() => {
              setIsLogin(true);
              setIsSetPassword(false);
              setIsSignUp(false);
              setSignupStep("");
              setIsForgot(false);
              setIsOtp(false);
            }}
            onClose={() => {
              setIsSignUp(false);
              setSignupStep("0");
              setIsForgot(false);
              setIsSetPassword(false);
              setIsOtp(false);
              setIsLogin(false);
            }}
            setSignupStep={() => setSignupStep("1")}
          />
        )}
        {isSignUp && signStepup == "1" && (
          <CoachSignUpStep1Modal
            backToLogin={() => {
              setIsLogin(true);
              setIsSignUp(false);
              setIsSetPassword(false);
              setSignupStep("");
              setIsForgot(false);
              setIsOtp(false);
            }}
            onClose={() => {
              setIsSignUp(false);
              setIsForgot(false);
              setIsOtp(false);
              setIsLogin(false);
              setSignupStep("0");
              setIsSetPassword(false);
            }}
            setSignupStep={() => setSignupStep("2")}
            stepBack={() => setSignupStep("0")}
          />
        )}
        {isSignUp && signStepup == "2" && (
          <CoachSignUpStep2Modal
            isLoad={isLoad}
            backToLogin={() => {
              setIsLogin(true);
              setIsSignUp(false);
              setSignupStep("");
              setIsForgot(false);
              setIsSetPassword(false);
              setIsOtp(false);
            }}
            onClose={() => {
              setIsSignUp(false);
              setSignupStep("0");
              setIsForgot(false);
              setIsOtp(false);
              setIsSetPassword(false);
              setIsLogin(false);
            }}
            setSignupStep={() => setSignupStep("3")}
            stepBack={() => setSignupStep("1")}
          />
        )}
        {isSignUp && signStepup == "3" && (
          <CoachSignUpStep3Modal
            onClose={() => {
              setIsSignUp(false);
              setSignupStep("0");
              setIsForgot(false);
              setIsOtp(false);
              setIsLogin(false);
              setIsSetPassword(false);
            }}
            setSignupStep={() => setSignupStep("4")}
            stepBack={() => setSignupStep("2")}
          />
        )}
        {isLogin && (
          <CoachLogin
            onSignUp={() => {
              setIsSignUp(true);
              setIsLogin(false);
              setSignupStep("0");
              setIsForgot(false);
              setIsOtp(false);
              setIsSetPassword(false);
            }}
            onClose={() => {
              setIsForgot(false);
              setIsOtp(false);
              setIsSignUp(false);
              setIsLogin(false);
              setIsSetPassword(false);
            }}
            onForgot={() => {
              setIsForgot(true);
              setIsLogin(false);
              setIsOtp(false);
              setIsSignUp(false);
              setIsSetPassword(false);
            }}
          />
        )}
        {isForgot && (
          <CoachForgotPassword
            backToLogin={() => {
              setIsLogin(true);
              setIsForgot(false);
              setIsOtp(false);
              setIsSignUp(false);
              setIsSetPassword(false);
            }}
            onClose={() => {
              setIsForgot(false);
              setIsOtp(false);
              setIsSignUp(false);
              setIsLogin(false);
              setIsSetPassword(false);
            }}
            otpScreen={() => {
              setIsOtp(true);
              setIsLogin(false);
              setIsForgot(false);
              setIsSignUp(false);
              setIsSetPassword(false);
            }}
            setData={(val, data) => {
              setDbCode(val);
              setEmail(data);
            }}
          />
        )}
        {isOtp && (
          <OtpVerification
            onClose={() => {
              setIsOtp(false);
              setIsForgot(false);
              setIsSignUp(false);
              setIsLogin(false);
              setIsSetPassword(false);
              setDbCode("");
              setEmail("");
            }}
            backToLogin={() => {
              setIsLogin(true);
              setIsForgot(false);
              setIsOtp(false);
              setIsSignUp(false);
              setIsSetPassword(false);
              setDbCode("");
              setEmail("");
            }}
            email={email}
            dbCode={dbCode}
            nextStep={() => setIsSetPassword(true)}
          />
        )}
        {isSetPassword && (
          <ResetPassword
            onClose={() => {
              setIsOtp(false);
              setIsForgot(false);
              setIsSignUp(false);
              setIsLogin(false);
              setIsSetPassword(false);
              setDbCode("");
              setEmail("");
            }}
            backToLogin={() => {
              setIsLogin(true);
              setIsForgot(false);
              setIsOtp(false);
              setIsSignUp(false);
              setIsSetPassword(false);
              setDbCode("");
              setEmail("");
            }}
            forgot_code={dbCode}
            handleFinalSubmit={() => {
              setDbCode("");
              setEmail("");
            }}
          />
        )}
      </>
    );
};

export default BootCampLayout;